import axiosInstance from '../axios';
import endpoints from '../endpoints';

const contestService = {

  // Get user's contests
  getUserContests: async (params = {}) => {
    const { page = 1, pageSize = 20, status, hostId, search } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    if (status) queryParams.append('status', status);
    if (hostId) queryParams.append('hostId', hostId);
    if (search) queryParams.append('search', search);
    
    const response = await axiosInstance.get(`${endpoints.contests.list}?${queryParams}`);
    return response.data;
  },


  // ✅ Get ALL contests (Super Admin only)
  getAllContests: async (params = {}) => {
    const { page = 1, pageSize = 100, status, search } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    if (status) queryParams.append('status', status);
    if (search) queryParams.append('search', search);
    
    const response = await axiosInstance.get(`/contests/admin/all?${queryParams}`);
    return response.data;
  },


  // Get all contests (admin)
  // getAllContests: async (params = {}) => {
  //   const { page = 1, pageSize = 20, status } = params;
  //   const queryParams = new URLSearchParams({
  //     page,
  //     pageSize,
  //     ...(status && { status })
  //   });
    
  //   const response = await axiosInstance.get(`${endpoints.contests.list}?${queryParams}`);
  //   return response.data;
  // },

  // Get public contests (no auth required)
  getPublicContests: async () => {
    const response = await axiosInstance.get(endpoints.contests.public);
    return response.data;
  },

  // Get single contest (admin)
  getContestById: async (contestId) => {
    const response = await axiosInstance.get(endpoints.contests.getById(contestId));
    return response.data;
  },

  // Get public contest details (no auth required)
  getPublicContestDetail: async (contestId) => {
    const response = await axiosInstance.get(endpoints.contests.publicDetail(contestId));
    return response.data;
  },

  // Create contest
  createContest: async (formData) => {
    const response = await axiosInstance.post(endpoints.contests.create, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Update contest
  updateContest: async (contestId, formData) => {
    const response = await axiosInstance.put(endpoints.contests.update(contestId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Delete contest
  deleteContest: async (contestId) => {
    const response = await axiosInstance.delete(endpoints.contests.delete(contestId));
    return response.data;
  },

  // Toggle pause contest
  togglePause: async (contestId) => {
    const response = await axiosInstance.patch(endpoints.contests.togglePause(contestId));
    return response.data;
  },

  // Toggle show results
  toggleResults: async (contestId) => {
    const response = await axiosInstance.patch(endpoints.contests.toggleResults(contestId));
    return response.data;
  },

  // Get contest statistics
  getContestStats: async (contestId) => {
    const response = await axiosInstance.get(endpoints.contests.stats(contestId));
    return response.data;
  }
};

export default contestService;